<template>
    <section>
        <div class="py-6 sm:py-8" v-if="!hideForm">
            <div class="relative sm:py-16">
                <div
                    class="
                        mx-auto
                        max-w-md
                        px-4
                        sm:max-w-3xl sm:px-6
                        lg:max-w-7xl lg:px-8
                    "
                >
                    <div
                        class="
                            relative
                            rounded-2xl
                            px-6
                            py-10
                            overflow-hidden
                            shadow-xl
                            sm:px-12 sm:py-20
                            transition-colors
                            duration-500
                        "
                        :class="{
                            'bg-yellow-600': form.state == 'yellow',
                            'bg-green-600': form.state == 'green',
                            'bg-blue-600': form.state == 'blue',
                            'bg-red-600': form.state == 'red',
                            'bg-indigo-600': form.state == 'indigo',
                        }"
                    >
                        <div
                            aria-hidden="true"
                            class="absolute inset-0 -mt-72 sm:-mt-32 md:mt-0"
                        >
                            <svg
                                class="absolute inset-0 h-full w-full"
                                preserveAspectRatio="xMidYMid slice"
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 1463 360"
                            >
                                <path
                                    class="
                                        text-opacity-40
                                        transition-colors
                                        duration-500
                                    "
                                    :class="{
                                        'text-yellow-500':
                                            form.state == 'yellow',
                                        'text-green-500': form.state == 'green',
                                        'text-blue-500': form.state == 'blue',
                                        'text-red-500': form.state == 'red',
                                        'text-indigo-500':
                                            form.state == 'indigo',
                                    }"
                                    fill="currentColor"
                                    d="M-82.673 72l1761.849 472.086-134.327 501.315-1761.85-472.086z"
                                />
                                <path
                                    class="
                                        text-opacity-40
                                        transition-colors
                                        duration-500
                                    "
                                    :class="{
                                        'text-yellow-700':
                                            form.state == 'yellow',
                                        'text-green-700': form.state == 'green',
                                        'text-blue-700': form.state == 'blue',
                                        'text-red-700': form.state == 'red',
                                        'text-indigo-700':
                                            form.state == 'indigo',
                                    }"
                                    fill="currentColor"
                                    d="M-217.088 544.086L1544.761 72l134.327 501.316-1761.849 472.086z"
                                />
                            </svg>
                        </div>
                        <div class="relative">
                            <div class="sm:text-center">
                                <h2
                                    class="
                                        text-3xl
                                        font-extrabold
                                        text-white
                                        tracking-tight
                                        sm:text-4xl
                                    "
                                >
                                    {{ texts.title }}
                                </h2>
                                <span
                                    class="
                                        inline-flex
                                        items-center
                                        px-4
                                        py-1
                                        mt-4
                                        rounded-full
                                        text-base
                                        font-medium
                                        bg-yellow-100
                                        text-yellow-800
                                    "
                                >
                                    {{
                                        t(
                                            "proxy-vote.your-votingweight",
                                            "Uw stemgewicht is:"
                                        )
                                    }}&nbsp;
                                    <kbd
                                        class="text-base"
                                        v-if="user.voting_weight"
                                        no-if="
                                            user.voting_weight &&
                                            user.phone != 'error'
                                        "
                                        ><b>{{ user.voting_weight }}</b></kbd
                                    >
                                </span>
                                <p
                                    v-if="texts.content"
                                    class="mt-4 mx-auto max-w-2xl text-lg mb-2"
                                    :class="{
                                        'text-yellow-50':
                                            form.state == 'yellow',
                                        'text-green-50': form.state == 'green',
                                        'text-blue-50': form.state == 'blue',
                                        'text-red-50': form.state == 'red',
                                        'text-indigo-50':
                                            form.state == 'indigo',
                                    }"
                                >
                                    <abbr
                                        v-if="
                                            user.phone != 'error' && user.name
                                        "
                                        :title="user.email"
                                        >{{ user.name }},&nbsp;</abbr
                                    >
                                    <span v-html="texts.content"></span>
                                </p>
                            </div>

                            <form
                                v-on:submit.prevent="confirmTransfer"
                                novalidate
                                v-if="form.type == 'validate-transfer'"
                                class="
                                    mt-6
                                    mx-auto
                                    sm:max-w-xl sm:flex-1
                                    text-center
                                "
                            >
                                <div
                                    v-if="texts.button"
                                    class="
                                        mt-4
                                        sm:mt-0 sm:ml-3
                                        mx-auto
                                        inline-block
                                        text-center
                                    "
                                >
                                    <a
                                        v-if="!loading"
                                        href="/"
                                        class="
                                            inline
                                            rounded-md
                                            border border-transparent
                                            px-5
                                            py-3
                                            text-base
                                            font-medium
                                            text-white
                                            shadow
                                            focus:outline-none
                                            focus:ring-2
                                            focus:ring-white
                                            focus:ring-offset-2
                                            sm:px-10
                                            bg-red-500
                                            hover:bg-red-400
                                            focus:ring-offset-red-600
                                            mr-2
                                        "
                                    >
                                        <span>{{
                                            t("cancel", "Annuleren")
                                        }}</span>
                                    </a>

                                    <button
                                        v-if="!loading"
                                        type="submit"
                                        class="
                                            inline
                                            rounded-md
                                            border border-transparent
                                            px-5
                                            py-3
                                            text-base
                                            font-medium
                                            text-white
                                            shadow
                                            focus:outline-none
                                            focus:ring-2
                                            focus:ring-white
                                            focus:ring-offset-2
                                            sm:px-10
                                            bg-green-500
                                            hover:bg-green-400
                                            focus:ring-offset-green-600
                                            ml-2
                                        "
                                    >
                                        <span class="font-semibold">{{
                                            texts.button
                                        }}</span>
                                    </button>
                                    <icon-loader
                                        v-if="loading"
                                        class="
                                            text-white
                                            mt-3
                                            inline-block
                                            transition-all
                                            duration-500
                                            ease-in-out
                                            mx-auto
                                        "
                                    ></icon-loader>
                                </div>
                            </form>

                            <form
                                v-on:submit.prevent="findAttendee"
                                novalidate
                                v-if="form.type == 'search-attendee'"
                                class="mt-6 sm:mx-auto sm:max-w-xl sm:flex"
                            >
                                <div class="min-w-0 flex-1">
                                    <label for="otc" class="sr-only">{{
                                        texts.button
                                    }}</label>
                                    <input
                                        type="email"
                                        id="otc"
                                        ref="email"
                                        v-model="form.input.email"
                                        :disabled="loading"
                                        class="
                                            block
                                            w-full
                                            border border-transparent
                                            rounded-md
                                            px-5
                                            py-3
                                            text-base text-gray-900
                                            placeholder-gray-500
                                            shadow-sm
                                            focus:outline-none
                                            focus:border-transparent
                                            focus:ring-2
                                            focus:ring-white
                                            focus:ring-offset-2
                                            focus:ring-offset-blue-600
                                            disabled:opacity-50
                                        "
                                        :placeholder="form.placeholder"
                                    />
                                </div>
                                <div class="mt-4 sm:mt-0 sm:ml-3 mx-auto">
                                    <button
                                        v-if="!loading"
                                        type="submit"
                                        class="
                                            block
                                            w-full
                                            rounded-md
                                            border border-transparent
                                            px-5
                                            py-3
                                            text-base
                                            font-medium
                                            text-white
                                            shadow
                                            focus:outline-none
                                            focus:ring-2
                                            focus:ring-white
                                            focus:ring-offset-2
                                            sm:px-10
                                        "
                                        :class="{
                                            'bg-yellow-500 hover:bg-yellow-400 focus:ring-offset-yellow-600':
                                                form.state == 'yellow',
                                            'bg-green-500 hover:bg-green-400 focus:ring-offset-green-600':
                                                form.state == 'green',
                                            'bg-blue-500 hover:bg-blue-400 focus:ring-offset-blue-600':
                                                form.state == 'blue',
                                            'bg-red-500 hover:bg-red-400 focus:ring-offset-red-600':
                                                form.state == 'red',
                                            'bg-indigo-500 hover:bg-indigo-400 focus:ring-offset-indigo-600':
                                                form.state == 'indigo',
                                        }"
                                    >
                                        <span>{{ texts.button }} </span>
                                    </button>
                                    <icon-loader
                                        v-if="loading"
                                        class="
                                            text-white
                                            mt-3
                                            inline-block
                                            transition-all
                                            duration-500
                                            ease-in-out
                                            mx-auto
                                        "
                                    ></icon-loader>
                                </div>
                            </form>
                        </div>
                    </div>

                    <footer class="my-4 flex justify-center">
                        <a
                            class="
                                max-w-xl
                                mx-auto
                                text-sm
                                my-6
                                leading-5
                                text-gray-500
                            "
                            title="Log off"
                            href="/logoff"
                            ><svg
                                class="w-6 h-6"
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-width="2"
                                    d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"
                                ></path></svg
                        ></a>
                    </footer>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import { SupportIcon, XIcon } from "@heroicons/vue/outline";
import Swal from "sweetalert2";
export default {
    components: {
        SupportIcon,
        XIcon,
    },
    data() {
        return {
            texts: {
                title: "Volmacht verlenen",
                content:
                    "u kunt uw stemgewicht overdragen naar een andere deelnemer. Voer daarvoor hieronder het e-mailadres is van de deelnemer welke u wilt volmachten om voor u te stemmen.",
                topbar: "Hulp nodig? Bekijk hier de instructie-video's.",
                button: "Zoek gebruiker",
            },
            user: {
                email: null,
                name: null,
                phone: null,
                has_pin: false,
                hide_2fa: false,
            },
            form: {
                type: "search-attendee",
                state: "blue",
                errors: null,
                success: false,
                placeholder: "E-mailadres van andere gebruiker",
                input: {
                    email: "",
                    code: null,
                },
            },
            loading: false,
            hideForm: false,
        };
    },
    created() {
        Eventing.fire("checkAuthStatus");
        this.user = {
            email: document.head.querySelector('meta[name="email"]').content,
            name: document.head.querySelector('meta[name="name"]').content,
            phone: document.head.querySelector('meta[name="phone"]').content,
            voting_weight: parseInt(
                document.head.querySelector('meta[name="voting_weight"]')
                    .content
            ),
        };
        let self = this;
        this.texts = {
            title: self.t("proxy-vote.title", "Volmacht verlenen"),
            content: self.t(
                "proxy-vote.content",
                "u kunt uw stemgewicht overdragen naar een andere deelnemer. Voer daarvoor hieronder het e-mailadres is van de deelnemer welke u wilt volmachten om voor u te stemmen."
            ),
            topbar: self.t(
                "proxy-vote.topbar",
                "Hulp nodig? Bekijk hier de instructie-video's."
            ),
            button: self.t("proxy-vote.button", "Zoek gebruiker"),
        };
        this.form.placeholder = self.t(
            "proxy-vote.placeholder",
            "E-mailadres van andere gebruiker"
        );

        // alert(this.user.voting_weight);
        if (this.user.voting_weight < 0 || !this.user.voting_weight) {
            this.hideForm = true;
            var isProxied =
                document.head.querySelector('meta[name="proxy_vote_status"]')
                    .content == "true"
                    ? true
                    : false;
            if (isProxied) {
                this.revokeProxyvote();
            } else {
                Swal.fire(
                    self.t(
                        "proxy-vote.alert-403-title",
                        "Volmachten niet mogelijk"
                    ),
                    self.t(
                        "proxy-vote.alert-403-content",
                        "U hebt geen stemgewicht (meer) om over te dragen"
                    ),
                    "error"
                ).then(function () {
                    return (window.location.href = "/");
                });
            }
        }
    },
    methods: {
        confirmTransfer() {
            let self = this;
            Swal.fire({
                title: self.t("proxy-vote.alert-confirm-title", "Zeker weten?"),
                text: self.t(
                    "proxy-vote.alert-confirm-text",
                    "Dit kan niet ongedaan worden gemaakt"
                ),
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#de3618",
                cancelButtonColor: "#333",
                confirmButtonText: self.t("yes"),
                cancelButtonText: self.t("cancel"),
            }).then((result) => {
                if (result.value) {
                    self.loading = true;
                    axios
                        .post("/api/proxyvoting/transfer", {
                            email: this.form.input.email.toLowerCase(),
                        })
                        .then((response) => {
                            this.texts = {
                                title: self.t(
                                    "proxy-vote.transfer-success-title",
                                    "Volmacht overgedragen"
                                ),
                                content: self.t(
                                    "proxy-vote.transfer-success-content",
                                    "U hebt <b>:value</b> als gevolmachtigde doorgegeven.",
                                    response.data.name
                                ),
                                // content:
                                //     "U hebt <b>" +
                                //     response.data.name +
                                //     "</b> als gevolmachtigde doorgegeven.",

                                topbar: "",
                                button: "",
                            };

                            self.user.voting_weight = self.t(
                                "proxy-vote.overgedragen",
                                "overgedragen"
                            );

                            self.form.state = "green";

                            self.loading = false;
                            document.head.querySelector(
                                'meta[name="proxy_vote_status"]'
                            ).content = "false";
                            Eventing.fire("toggleProxy");
                        })
                        .catch((error) => {
                            if (error.response.status == 404) {
                                self.$router.push("/login");
                            }
                            if (
                                error.response.status == 409 &&
                                error.response.data &&
                                error.response.data.error
                            ) {
                                self.loading = false;
                                self.form.state = "red";
                                // Terug naar stap 1, zodat een ander e-mailadres
                                // ingevoerd kan worden.
                                self.form.type = "search-attendee";
                                self.texts.title = self.t(
                                    "proxy-vote.max-reached-title",
                                    "Maximum bereikt"
                                );
                                self.texts.content = error.response.data.error;
                                self.texts.button = self.t(
                                    "proxy-vote.button",
                                    "Zoek gebruiker"
                                );
                                Swal.fire(
                                    self.texts.title,
                                    error.response.data.error,
                                    "error"
                                );

                                return;
                            }
                            alert("Daar ging wat mis");
                        });
                }
            });
        },

        revokeProxyvote() {
            let self = this;
            Swal.fire({
                title: self.t(
                    "proxy-vote.revoke-confirm-title",
                    "Zeker weten?"
                ),
                text: self.t(
                    "proxy-vote.revoke-confirm-text",
                    "Volmacht intrekken?"
                ),
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#de3618",
                cancelButtonColor: "#333",
                confirmButtonText: self.t("yes"),
                cancelButtonText: self.t("cancel"),
            }).then((result) => {
                if (result.value) {
                    self.loading = true;
                    axios
                        .post("/api/proxyvoting/revoke", {
                            // email: this.form.input.email.toLowerCase(),
                        })
                        .then((response) => {
                            this.texts = {
                                title: self.t(
                                    "proxy-vote.revoked-success-title",
                                    "Volmacht ingetrokken"
                                ),
                                // content:
                                //     "U hebt <b>" +
                                //     response.data.name +
                                //     "</b> als gevolmachtigde doorgegeven.",
                                content: self.t(
                                    "proxy-vote.revoked-success-title",
                                    "U hebt <b>:value</b> als gevolmachtigde ingetrokken.",
                                    response.data.name
                                ),
                                topbar: "",
                                button: "",
                            };

                            self.user.voting_weight =
                                response.data.voting_weight;

                            self.form.state = "green";

                            self.loading = false;
                            // window.location.href = "/app#";
                            Eventing.fire("toggleProxy"); 
                        })
                        .catch((error) => {
                            if (error.response.status == 404) {
                                self.$router.push("/login");
                            }
                            if (error.response.status == 409) {
                                // alert(error.response.data);
                            }
                            alert("Daar ging wat mis");
                        });
                } else {
                    self.$router.push("/dashboard");
                }
            });
        },

        findAttendee() {
            let self = this;
            this.loading = true;
            axios
                .post("/api/proxyvoting/search", {
                    email: this.form.input.email.toLowerCase(),
                })
                .then((response) => {
                    this.form.state = "indigo";
                    console.info(response.data);
                    // this.user = {};
                    this.loading = false;
                    this.user.name = null;
                    this.texts = {
                        title: response.data.name,

                        content: self.t(
                            "proxy-vote.transfer-confirm-text",
                            "Wilt u uw stemgewicht van <b>:value</b> overdragen aan <b>:value_2</b>?",
                            this.user.voting_weight,
                            response.data.name
                        ),
                        topbar: "",
                        button: self.t(
                            "proxy-vote.transfer-confirm-button",
                            "Bevestigen"
                        ),
                    };
                    this.form.type = "validate-transfer";
                    // this.$router.push("/dashboard");
                })
                .catch((error) => {
                    this.user.name = null;
                    self.form.state = "red";
                    if (error.response.status == 404) {
                        this.$router.push("/login");
                    } else if (error.response.status == 422) {
                        var errors = error.response.data.errors;
                        this.texts.content = errors["email"].toString();
                    } else if (error.response.status == 409) {
                        this.texts.content = error.response.data.error;
                    } else {
                        alert("Daar ging wat mis");
                    }
                    setTimeout(function () {
                        if (self.form.state == "red") {
                            self.form.state = "blue";
                        }
                    }, 3000);
                    this.loading = false;
                });
        },
    },
};
</script>
